<template>
	<div>
		<TopHeader :tabIndex='3'></TopHeader>

		<div class="cont">
			<Breadcrumb :pathList="pathList"></Breadcrumb>
			<div class="flex-only" style="margin-top: 20px;">
				<!-- <img :src="detail.img" style="width: 507px;height: 284px;border-radius: 13px;" /> -->
				<el-image style="width: 507px;height: 284px;border-radius: 13px;" :src="detail.img" :preview-src-list="$getImageList(detail.img)">
				</el-image>
				<div class="right flex-1">
					<div class="flex flex-b">
						<div class="name">{{detail.name}}</div>
						<!-- <img class="pointer" src="../../assets/icon/sc.png" style="width: 27px;height: 27px;" alt="" /> -->
						<!-- <img class="pointer" src="../../assets/icon/wsc.png" style="width: 27px;height: 27px;" alt="" /> -->
					</div>
					<div class="flex">
						<div class="flag flex flex-c">{{detail.course_cate_name}}</div>
					</div>
					<div class="lbox">
						<div class="t1">当前已解锁 {{buyChapter}}个章节</div>
					</div>
				</div>
			</div>
			<div class="navs flex">
				<div class="navItem pointer" :class="navIndex==0?'active':''" @click="navIndex=0">课程详情</div>
				<div class="navItem pointer" :class="navIndex==1?'active':''" @click="navIndex=1">课程章节</div>
				<div class="navItem pointer" :class="navIndex==2?'active':''" @click="navIndex=2">课程订单</div>
			</div>
			<template v-if="navIndex==0">
				<div class="titles">课程介绍</div>
				<div class="" v-html="detail.desc"></div>
				<div class="titles">课程大纲</div>
				<div class="lbox">
					<div class="flex-only botl" v-for="(item,index) in chapter">
						<div class="num">第{{index+1}}章</div>
						<div class="ml20">
							<div class="name">{{item.name}}</div>
							<div class="det">{{item.desc}}</div>
						</div>
					</div>
				</div>
				<div class="titles">相关课程推荐</div>
				<div class="flex">
					<div class="itembg pointer" v-for="item in recommend" @click="toCourseDetail(item)">
						<img :src="item.img" style="width: 100%;border-radius: 13px;" />
						<div class="ititle">{{item.name}}</div>
						<div class="price flex" style="margin-top: 12px;">{{item.score}}
							<div class="span">积分</div>
						</div>
					</div>
				</div>
			</template>
			<template v-if="navIndex==1">
				<div class="flex flex-b flex-wrap">
					<div class="lbox" v-for="(item,index) in userChapterList"
						style="padding: 30px;margin: 10px 0;width: 49%;">
						<div class="flex flex-b" style="margin-bottom: 14px;">
							<div class="flex">
								<div class="num">第{{index+1}}章</div>
								<div class="name" style="margin-left: 16px;">{{item.name}}</div>
							</div>
							<div>
								<div class="long" v-if="item.type==1">
									{{parseFloat(item.file.second/60).toFixed(1)<1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/视频
								</div>
								<div class="long" v-if="item.type==2">
									{{parseFloat(item.file.second/60).toFixed(1)<1?parseFloat(item.file.second)+'秒':parseFloat(item.file.second/60).toFixed(1)+'分钟'}}/音频
								</div>
								<div class="long" v-if="item.type==3">PDF</div>
								<div class="long" v-if="item.type==4">PPT</div>
								<div class="deline" v-if="item.end_time">{{item.end_time}} 到期</div>
								<div class="deline" v-else>未购买</div>
							</div>

						</div>
						<div class="flex flex-b">
							<div class="flex">
								<div class="vip1" style="margin: 6px 0 0 0;">
									{{loginUser.member?loginUser.member.name:''}}
								</div>
								<!-- <div class="vip2" style="margin: 6px 0 0 0;">星光银</div> -->
								<div class="score">{{item.member_score>0?item.member_score:0}}<span>积分</span></div>
								<div class="linePrice">{{item.score}}积分</div>
							</div>
							<div class="wxbtn pointer" @click="toStudyClick(item)" v-if="item.is_buy==1&&item.persent>0"
								style="width: 87px;height: 36px;margin-top: 0;">
								<span>{{item.persent==100?'重新学习':'播放视频'}}</span>
							</div>
							<div class="ygmBtn pointer flex flex-c" v-if="item.is_buy==1&&item.persent==0"
								@click="toStudyClick(item)">开始学习</div>
						</div>
					</div>
				</div>
				<Pagination :total="userChapterCount" :page_size="userChapterPageSize" @currentChange='currentChange'>
				</Pagination>
			</template>
			<template v-if="navIndex==2">
				<div class="flex-only flex-b flex-wrap">
					<div class="lbox" v-for="(item,index) in courseOrderList"
						style="padding: 20px 30px;margin: 10px 0;width: 49%;height: 100%;">
						<div class="flex flex-b" style="margin-bottom: 6px;">
							<div>
								<div class="tx1">{{item.create_time}}</div>
								<div class="tx2">购买 {{item.chapter.length}} 章课程</div>
							</div>
							<div class="wxbtn pointer" v-if="item.evaluate"
								style="width: 87px;height: 36px;margin-top: 0;" @click="viewEvaluateClick(item)">
								<span>查看评价</span>
							</div>
							<div class="ygmBtn flex flex-c pointer" v-if="!item.evaluate"
								@click="showEvaluateClick(item)">评价课程</div>
						</div>
						<div class="flex" style="margin: 10px 0;" v-for="(_item,_index) in item.chapter">
							<div class="num">第{{_index+1}}章</div>
							<div class="name" style="margin-left: 16px;">{{_item.name}}</div>
						</div>
						<div class="flex flex-b topl">
							<div class="sf">实付积分</div>
							<div class="score" style="color: #00A73C;">{{item.score}}<span
									style="color: #00A73C;">积分</span>
							</div>
						</div>
					</div>
				</div>
				<Pagination :total="courseOrderCount" :page_size="courseOrderPageSize"
					@currentChange='currentOrderChange'></Pagination>
			</template>
		</div>
		<el-dialog :visible.sync="showEvaluate" width="527px" :close-on-click-modal='false' :show-close="true"
			:close-on-press-escape='false'>
			<div class="showEvaluate" v-if="currentEvaluate">
				<div class="tit">课程评价</div>
				<div class="botl">
					<div class="tx1">{{currentEvaluate.create_time}}</div>
					<div class="tx2">购买 {{currentEvaluate.chapter.length}} 章课程</div>
					<div class="flex" style="margin: 10px 0;" v-for="(item,index) in currentEvaluate.chapter">
						<div class="num">第{{index+1}}章</div>
						<div class="name" style="margin-left: 16px;">{{item.name}}</div>
					</div>
				</div>
				<div class="flex flex-b" style="margin-top: 16px;">
					<div class="tx3">请为课程打分</div>
					<el-rate v-model="star" :disabled='viewEvaluate'></el-rate>
				</div>
				<el-input :disabled='viewEvaluate' type="textarea" placeholder="写下你的学习感受，可以帮助更多人哟~" v-model="content"
					maxlength="200" show-word-limit>
				</el-input>
				<div class="tip" v-if="!viewEvaluate"><span>*</span>完成评价可获得{{evaluateScore}}积分奖励</div>
				<div class="submit pointer" @click="toSubmitEvalute" v-if="!viewEvaluate">
					<span class="text">提交评论</span>
				</div>
			</div>
		</el-dialog>
		<toTop></toTop>
		<Footer></Footer>
	</div>
</template>

<script>
	import Utils from "@/jslibs/utils";
	import {
		getMyCourse,
		getUser,
		EditUser,
	} from '@/api/mine';
	import {
		getConfigList,
		getConfigDetail
	} from '@/api/common';
	import {
		getCourseDetail,
		addCollect,
		delCollect,
		getCourse,
		getCourseOrderEvaluate,
		getUserChapter,
		getCourseOrder,
		addCourseOrderEvaluate,
		putUserChapter
	} from "@/api/course";
	import TopHeader from "../../components/TopHeader.vue";
	import Footer from "../../components/Footer.vue";
	import Breadcrumb from "../../components/Breadcrumb.vue";
	import Pagination from "../../components/Pagination.vue";
	import toTop from "../../components/toTop.vue";
	export default {
		data() {
			return {
				navIndex: 1,
				showBackToTop: false, // 控制按钮的显示
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '我的课程',
					path: '/allCourse'
				}, {
					title: '切割机操作进阶',
					path: ''
				}],
				showEvaluate: false, //评价课程
				star: 0, //评分
				textarea: '',
				id: '',
				courseList: [],
				chapter: [],
				detail: '',
				userChapterCount: 0,
				userChapterList: [],
				userChapterPageSize: 10,
				userChapterPageIndex: 1,
				loginUser: '',
				courseOrderPageIndex: 1,
				courseOrderPageSize: 10,
				courseOrderList: [],
				courseOrderCount: 0,
				evaluateScore: 0,
				currentEvaluate: '',
				buyChapter: 0,
				content: '',
				viewEvaluate: false,
				recommend:[]
			}
		},
		components: {
			TopHeader,
			Footer,
			Breadcrumb,
			Pagination,
			toTop
		},
		watch: {
			'$route.query.id'(newVal, oldVal) {
				this.id = newVal
				this.getCourseDetail()
			}
		},
		mounted() {
			this.id = this.$route.query.id
			if (Utils.getCookie('loginUser')) {
				this.getUser()
			}
			this.getCourseDetail()
			this.getUserChapter()
			this.getCourseOrder()
			this.getConfigList()
		},
		methods: {
			toStudyClick(item) {
				if (item.type == 1 || item.type == 2) {
					//视频/音频
					this.$router.push({
						path: '/studyVideo?chapterId=' + item.uuid + '&courseId=' + this.detail.uuid
					})
				}
				// if (item.type == 2) {
				// 	//音频
				// 	this.$router.push({
				// 		path: '/studyVideo?id=' + item.uuid
				// 	})
				// }
				if (item.type == 3 || item.type == 4) {
					this.putUserChapter(item.uuid)
					//pdf/ppt
					if (item.is_buy == 1) {
						window.open('http://api.idocv.com/view/url?url=' + item.file.url)
					} else {
						window.open('http://api.idocv.com/view/url?url=' + item.fee_file.url)
					}
				}
			},
			//提交学习进度
			async putUserChapter(uuid) {
				const {
					status,
					data
				} = await putUserChapter({
					uuid: uuid,
					persent: 100
				})
			},
			async toSubmitEvalute() {
				if (this.star == 0) {
					this.$message({
						message: "请选择评分",
						type: "warning"
					});
					return
				}
				if (!this.content) {
					this.$message({
						message: "请填写评价内容",
						type: "warning"
					});
					return
				}
				const {
					status,
					data
				} = await addCourseOrderEvaluate({
					star: this.star,
					content: this.content,
					course_order_uuid: this.currentEvaluate.uuid
				});
				if (data.result) {
					this.$message({
						message: "评价成功",
						type: "success"
					});
					this.getCourseOrder()
				}
				this.showEvaluate = false
			},
			viewEvaluateClick(item) {
				this.showEvaluate = true
				this.currentEvaluate = item
				this.content = this.currentEvaluate.evaluate.content
				this.star = this.currentEvaluate.evaluate.star
				this.viewEvaluate = true
			},
			showEvaluateClick(item) {
				this.showEvaluate = true
				this.currentEvaluate = item
				this.content = ''
				this.star = 0
				this.viewEvaluate = false
			},
			async getConfigList() {
				const {
					status,
					data
				} = await getConfigList({});
				this.evaluateScore = data.result.find(item => {
					return item.key == 'EAVLUATE'
				}).value
			},
			currentOrderChange(e) {
				this.courseOrderPageIndex = e
				this.getCourseOrder()
			},
			async getCourseOrder() {
				const {
					status,
					data
				} = await getCourseOrder({
					course_uuid: this.id,
					page_index: this.courseOrderPageIndex,
					page_size: this.courseOrderPageSize
				});
				this.courseOrderList = data.result.data
				this.courseOrderCount = data.result.total
			},
			async getUser() {
				const {
					status,
					data
				} = await getUser({})
				this.loginUser = data.result
			},
			async getUserChapter() {
				const {
					status,
					data
				} = await getUserChapter({
					course_uuid: this.id,
					page_index: this.userChapterPageIndex,
					page_size: this.userChapterPageSize
				});
				this.userChapterList = data.result.data
				this.userChapterCount = data.result.total
				const arrs = []
				this.userChapterList.forEach(item => {
					if (item.is_buy == 1) {
						arrs.push(item)
					}
				})
				this.buyChapter = arrs.length
			},
			toCourseDetail(item) {
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.uuid,
						course_cate_name: item.course_cate_name
					}
				})
			},
			async getCourseDetail() {
				const {
					status,
					data
				} = await getCourseDetail({
					uuid: this.id,
				});
				this.detail = data.result
				this.chapter = this.detail.chapter
				this.chapter.forEach(item => {
					this.$set(item, 'selStatus', 0)
				})
				this.pathList[2].title = this.detail.name
				// this.getCourse()
				this.recommend = this.detail.recommend
			},
			async getCourse() {
				const {
					status,
					data
				} = await getCourse({
					page_inde: 1,
					page_size: 4,
					course_cate_uuid: this.detail.course_cate_uuid
				});
				this.courseList = data.result.data
			},
			//改变页数
			currentChange(e) {
				this.userChapterPageIndex = e
				this.getUserChapter()
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
			goBack() {
				this.$router.go(-1)
			},
		}
	}
</script>

<style lang="less" scoped>
	::v-deep .el-breadcrumb__inner.is-link:hover {
		color: #000;
	}

	::v-deep .is-link {
		color: #999 !important;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
	}

	::v-deep .el-breadcrumb__separator {
		font-size: 16px !important;
	}

	::v-deep .el-breadcrumb__inner {
		a {
			font-size: 16px !important;
			color: #000 !important;
			font-weight: 500 !important;
		}
	}

	::v-deep .el-breadcrumb__item {
		float: none;
	}

	.login-btn {
		margin-top: 10px;
		width: 164px;
		height: 50px;
		background: url('../../assets/images/course/btnw164.png') no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.submit {
		margin-top: 10px;
		width: 460px;
		height: 46px;
		background: url('../../assets/images/mine/sumbit.png') no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.cont {
		padding: 30px 133px 0;

		.el-icon-star-off,
		.el-icon-star-on {
			width: 50px;
		}

		.right {
			margin-left: 20px;

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 27px;
				color: #000000;
			}

			.flag {
				margin: 10px 0;
				height: 22px;
				padding: 0 10px;
				background: rgba(0, 167, 60, 0.06);
				border-radius: 4px 4px 4px 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
			}

			.lbox {
				width: 30%;
				border-radius: 9px 9px 9px 9px;
				border: 1px solid #EEEEEE;
				padding: 20px;
				margin: 20px 0;

				.t1 {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #000000;
				}

				.vip {
					height: 22px;
					line-height: 22px;
					padding: 0 10px;
					background: rgba(215, 177, 85, 0.06);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #D7B155;
				}

				.t2 {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 22px;
					color: #00A73C;

					span {
						margin-left: 6px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #00A73C;
					}
				}

				.t3 {
					padding-top: 10px;
					margin-left: 14px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #CCCCCC;
					text-decoration-line: line-through;
				}
			}
		}

		.wxbtn {
			margin-top: 10px;
			width: 164px;
			height: 44px;
			border-radius: 12px 12px 12px 12px;
			border: 2px solid rgba(127, 218, 76, .24);
			display: flex;
			align-items: center;
			justify-content: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}

		.navs {
			margin: 30px 0;
			justify-content: center;
			border-top: 1px solid #EEEEEE;
			border-bottom: 1px solid #EEEEEE;

			.navItem {
				margin: 0 80px;
				line-height: 60px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 20px;
				color: #666666;
			}

			.active {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: bold;
				font-size: 20px;
				color: #000000;
				position: relative;

				&::after {
					position: absolute;
					content: '';
					bottom: 0;
					left: 0;
					width: 100%;
					height: 4px;
					background: #00A73C;
				}
			}
		}

		.lbox {
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 0 20px;

			.botl {
				padding: 16px 0;
				border-bottom: 1px solid #EEEEEE;

				.ml20 {
					margin-left: 20px;
				}

				.det {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #666666;
				}
			}

			.num {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #999999;
			}

			.name {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.time {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}

			.tx1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}

			.tx2 {
				margin-top: 4px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #D7B155;
			}

			.topl {
				margin-top: 20px;
				padding-top: 6px;
				border-top: 1px solid #EEEEEE;
			}

			.sf {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 16px;
				color: #333333;
			}
		}

		.itembg {
			width: calc(25% - 27px);
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 9px 11px;
			margin-right: 20px;

			.ititle {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000000;
				margin-top: 13px;
			}

			.price {
				font-family: DINPro, DINPro;
				font-weight: bold;
				font-size: 22px;
				color: #00A73C;

				.span {
					margin-left: 2px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;
					margin-top: 5px;
				}
			}
		}

		.tit {
			margin-bottom: 20px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FC5F5F;
			}
		}

		.vip1 {
			margin-left: 10px;
			height: 22px;
			background: rgba(215, 177, 85, 0.06);
			border-radius: 4px 4px 4px 4px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #D7B155;
			line-height: 22px;
			padding: 0 10px;
		}

		.vip2 {
			margin-left: 10px;
			height: 22px;
			background: rgba(191, 201, 210, 0.06);
			border-radius: 8px 8px 8px 8px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #99A7B5;
			line-height: 22px;
			padding: 0 10px;
		}

		.long {
			text-align: right;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
		}

		.deline {
			margin-top: 4px;
			text-align: right;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #D7B155;
		}

		.ygmBtn {
			width: 87px;
			line-height: 36px;
			height: 36px;
			background: linear-gradient(136deg, #7FDA4C 0%, #10B649 100%);
			border-radius: 11px 11px 11px 11px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			color: #FFFFFF;
		}
	}

	::v-deep .el-dialog__header {
		padding: 0;
	}

	::v-deep .el-dialog__body {
		padding: 20px;
	}

	::v-deep .el-rate__icon {
		font-size: 26px;

		&.el-icon-star-on {
			font-size: 32px;
			color: #eed9a3 !important;
		}
	}

	.showEvaluate {
		.tit {
			text-align: center;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 20px;
			color: #000000;
		}

		.botl {
			padding: 10px 0;
			border-bottom: 1px solid #EEEEEE;
		}

		.tx1 {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 18px;
			color: #333333;
		}

		.tx2 {
			margin-top: 4px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #D7B155;
		}

		.num {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}

		.name {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 500;
			font-size: 16px;
			color: #333333;
		}

		.tx3 {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000000;
		}

		textarea {
			margin: 20px 0;
			width: 100%;
			border: none;
			padding: 16px;
			height: 306px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000;

			&:focus {
				outline: none;
			}
		}

		.tip {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #333;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #FC5F5F;
			}
		}
	}

	::v-deep .el-dialog__close {
		font-size: 26px;
	}

	::v-deep .el-dialog__headerbtn:hover .el-dialog__close {
		color: #999 !important;
	}

	::v-deep .el-textarea {
		margin: 20px 0;

		.el-textarea__inner {
			height: 306px;
			border: none;
			padding: 14px;
			background: #F7F8F9;
			border-radius: 13px 13px 13px 13px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #333;
		}
	}
</style>